import { FC, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { Icons } from '@beeline/design-tokens/js/iconfont';

import clsx from 'clsx';
import { EmployeePermission } from 'src/api/permissions';
import { DeskPlace } from 'src/components/DeskPlace/DeskPlace';
import { getCurrentDesk, getFilteredDesks } from 'src/store/desks/selectors';
import { getUserState } from 'src/store/user/selectors';
import { Desk } from 'src/types';

import classes from './BookingDeskPlace.module.scss';

export interface BookingDeskPlaceProps {
  item: Desk;
}

export const BookingDeskPlace: FC<BookingDeskPlaceProps> = ({ item }) => {
  const desk = useSelector(getCurrentDesk);
  const { data } = useSelector(getUserState);
  const filteredBookingObjects = useSelector(getFilteredDesks);

  let bookedByMe = false;
  let bookedByCollegue = false;

  if (item.status) {
    if (item.status.responsibleEmployeeNumber === data?.employeeNumber) {
      bookedByMe = true;
    } else {
      bookedByCollegue = true;
    }
  }

  const reservedBySpace =
    !data?.permissions.has(EmployeePermission.BookForOthers) &&
    !!item.spaceId &&
    !data?.spaces.has(item.spaceId);
  const reservedByResponsible =
    item.responsibleEmployeeNumber &&
    item.responsibleEmployeeNumber !== data?.employeeNumber;
  const reserved = reservedBySpace || reservedByResponsible;

  const disabled = !filteredBookingObjects.has(item.mapPlaceId);

  const active = desk?.mapPlaceId === item.mapPlaceId;

  const [hovered, setHovered] = useState(false);

  const handleMouseOver = useCallback(() => {
    setHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHovered(false);
  }, []);

  return (
    <DeskPlace
      item={item}
      figureClassName={disabled ? undefined : classes.figure}
      deskClassName={clsx(
        classes.desk,
        bookedByMe && classes.bookedByMe,
        (bookedByCollegue || reserved) && classes.reserved,
        active && classes.active,
      )}
      chairClassName={clsx(
        classes.chair,
        bookedByMe && classes.bookedByMe,
        (bookedByCollegue || reserved) && classes.reserved,
        active && classes.active,
      )}
      titleClassName={clsx(
        classes.title,
        bookedByMe && classes.bookedByMeTitle,
        (bookedByCollegue || reserved) && classes.titleReserved,
        active && classes.titleActive,
      )}
      iconName={
        bookedByMe ? Icons.User : reserved && !hovered ? Icons.Lock : undefined
      }
      disabled={disabled}
      title={reserved ? 'Зарезервировано' : undefined}
      onMouseLeave={handleMouseLeave}
      onMouseOver={handleMouseOver}
    />
  );
};
